import { render, staticRenderFns } from "./UploadThumb.vue?vue&type=template&id=ff197000&scoped=true&"
import script from "./UploadThumb.vue?vue&type=script&lang=ts&"
export * from "./UploadThumb.vue?vue&type=script&lang=ts&"
import style0 from "./UploadThumb.vue?vue&type=style&index=0&id=ff197000&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff197000",
  null
  
)

export default component.exports